import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    eventCountStats: null,
    eventCountStatsLoading: false,
    athleteCountStats: null,
    athleteCountStatsLoading: false,
    competitionCountStats: null,
    competitionCountStatsLoading: false,
    invoicedAmountStats: null,
    invoicedAmountStatsLoading: false
  },
  mutations: {
    setEventCountStats(state, payload) {
      state.eventCountStats = payload;
    },
    setEventCountStatsLoading(state, payload) {
      state.eventCountStatsLoading = payload;
    },
    setCompetitionCountStats(state, payload) {
      state.competitionCountStats = payload;
    },
    setCompetitionCountStatsLoading(state, payload) {
      state.competitionCountStatsLoading = payload;
    },
    setAthleteCountStats(state, payload) {
      state.athleteCountStats = payload;
    },
    setAthleteCountStatsLoading(state, payload) {
      state.athleteCountStatsLoading = payload;
    },
    setInvoicedAmountStats(state, payload) {
      state.invoicedAmountStats = payload;
    },
    setInvoicedAmountLoading(state, payload) {
      state.invoicedAmountStatsLoading = payload;
    }
  },
  actions: {
    async loadEventCount({ commit }) {
      commit("setEventCountStatsLoading", true);
      let eventCountStats = await api.get("/stats/eventsCount");
      commit("setEventCountStats", eventCountStats.data[0]);
      commit("setEventCountStatsLoading", false);
    },
    async loadCompetitionCount({ commit }) {
      commit("setCompetitionCountStatsLoading", true);
      let competitionCountStats = await api.get("/stats/competitionsCount");
      commit("setCompetitionCountStats", competitionCountStats.data[0]);
      commit("setCompetitionCountStatsLoading", false);
    },
    async loadAthleteCount({ commit }) {
      commit("setAthleteCountStatsLoading", true);
      // let athleteCountStats = await api.get("/stats/athletesCount");
      // commit("setAthleteCountStats", athleteCountStats.data[0]);
      commit("setAthleteCountStats", null);
      commit("setAthleteCountStatsLoading", false);
    },
    async loadInvoicedAmount({ commit }) {
      commit("setInvoicedAmountLoading", true);
      let invoicedAmount = await api.get("/stats/invoicedAmount");
      commit("setInvoicedAmountStats", invoicedAmount.data[0]);
      commit("setInvoicedAmountLoading", false);
    }
  },
  getters: {
    eventCountStats(state) {
      return state.eventCountStats;
    },
    eventCountStatsLoading(state) {
      return state.eventCountStatsLoading;
    },
    competitionCountStats(state) {
      return state.competitionCountStats;
    },
    competitionCountStatsLoading(state) {
      return state.competitionCountStatsLoading;
    },
    athleteCountStats(state) {
      return state.athleteCountStats;
    },
    athleteCountStatsLoading(state) {
      return state.athleteCountStatsLoading;
    },
    invoicedAmountStats(state) {
      return state.invoicedAmountStats;
    },
    invoicedAmountStatsLoading(state) {
      return state.invoicedAmountStatsLoading;
    }
  }
};
